import { useSupabaseLoader } from "../../../../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../../../../server/supabase/hooks/types";
import type { MomentPreviewTags } from "../../../../../server/supabase-preview-service";
import { SupabaseMomentPreviewService } from "../../../../../server/supabase-preview-service";
import type { EmailPreviewSource } from "./use-email-preview-source";

export function usePreviewTestData(
  source: EmailPreviewSource,
): UseSupabaseLoaderState<MomentPreviewTags> {
  const { design, subject, additional_merge_fields, use_unlayer_email_preview } = source;

  return useSupabaseLoader(
    async ({ supabase }): Promise<MomentPreviewTags> => {
      if (!design && !use_unlayer_email_preview) return [];

      const response = await new SupabaseMomentPreviewService(supabase).getMomentPreviewTestData(
        design,
        subject,
        additional_merge_fields,
      );

      if (response.error) {
        console.error(response.error);
        return [];
      }

      return response.data.map((x) => ({ key: x.key, value: x.merge_sample }));
    },
    [design, subject, additional_merge_fields, use_unlayer_email_preview],
  );
}
